// extracted by css-extract-rspack-plugin
var _1 = "gU1Tf";
var _2 = "SFQkX";
export { _1 as "appModule", _2 as "fullBleed" }
